
<iframe
  class="map"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2611.868536260222!2d6.167629476857395!3d49.10813788309797!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4794dc0f72f8787f%3A0xed01f05b10921687!2s29%20Rue%20Pasteur%2C%2057000%20Metz!5e0!3m2!1sfr!2sfr!4v1742451163410!5m2!1sfr!2sfr" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
</iframe>
